import React from "react";
import SvgIcon from "@mui/material/SvgIcon";

export const AudioWaves = (props) => {
  return (
    <SvgIcon
      {...props}
      style={{ fill: props.fill || "transparent" }}
      viewBox={props.viewBox || "0 0 52 38"}
      width="52"
      height="38"
    >
      <path
        d="M2 17V21"
        stroke="#F3F3F3"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M8 12L8 25.6364"
        stroke="#F3F3F3"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M14 2L14 36"
        stroke="#F3F3F3"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M20 9L20 28.0909"
        stroke="#F3F3F3"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M26 16L26 22"
        stroke="#F3F3F3"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M32 12L32 26"
        stroke="#F3F3F3"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M38 7L38 31"
        stroke="#F3F3F3"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M50 17V21"
        stroke="#F3F3F3"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M44 9L44 28.0909"
        stroke="#F3F3F3"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </SvgIcon>
  );
};

export const AudioRecorderWaves = (props) => {
  return (
    <SvgIcon
      {...props}
      style={{ fill: props.fill || "transparent" }}
      viewBox={props.viewBox || "0 0 221 78"}
      width="221"
      height="78"
    >
      <path
        d="M4 34.8335V43.1668"
        stroke="white"
        stroke-width="6.25"
        stroke-linecap="round"
      />
      <path
        d="M16.5 24.4167L16.5 52.8258"
        stroke="white"
        stroke-width="6.25"
        stroke-linecap="round"
      />
      <path
        d="M29 3.5835L29 74.4168"
        stroke="white"
        stroke-width="6.25"
        stroke-linecap="round"
      />
      <path
        d="M41.5 18.1667L41.5 57.9395"
        stroke="white"
        stroke-width="6.25"
        stroke-linecap="round"
      />
      <path
        d="M54 32.75L54 45.25"
        stroke="white"
        stroke-width="6.25"
        stroke-linecap="round"
      />
      <path
        d="M66.5 24.4167L66.5 53.5834"
        stroke="white"
        stroke-width="6.25"
        stroke-linecap="round"
      />
      <path
        d="M79 14L79 64"
        stroke="white"
        stroke-width="6.25"
        stroke-linecap="round"
      />
      <path
        d="M104 34.8335V43.1668"
        stroke="white"
        stroke-width="6.25"
        stroke-linecap="round"
      />
      <path
        d="M91.5 18.1667L91.5 57.9395"
        stroke="white"
        stroke-width="6.25"
        stroke-linecap="round"
      />
      <path
        d="M117 34.8335V43.1668"
        stroke="white"
        stroke-width="6.25"
        stroke-linecap="round"
      />
      <path
        d="M129.5 24.4167L129.5 52.8258"
        stroke="white"
        stroke-width="6.25"
        stroke-linecap="round"
      />
      <path
        d="M142 3.5835L142 74.4168"
        stroke="white"
        stroke-width="6.25"
        stroke-linecap="round"
      />
      <path
        d="M154.5 18.1667L154.5 57.9395"
        stroke="white"
        stroke-width="6.25"
        stroke-linecap="round"
      />
      <path
        d="M167 32.75L167 45.25"
        stroke="white"
        stroke-width="6.25"
        stroke-linecap="round"
      />
      <path
        d="M179.5 24.4167L179.5 53.5834"
        stroke="white"
        stroke-width="6.25"
        stroke-linecap="round"
      />
      <path
        d="M192 14L192 64"
        stroke="white"
        stroke-width="6.25"
        stroke-linecap="round"
      />
      <path
        d="M217 34.8335V43.1668"
        stroke="white"
        stroke-width="6.25"
        stroke-linecap="round"
      />
      <path
        d="M204.5 18.1667L204.5 57.9395"
        stroke="white"
        stroke-width="6.25"
        stroke-linecap="round"
      />
    </SvgIcon>
  );
};

export const AudioPlay = (props) => {
  return (
    <SvgIcon
      {...props}
      style={{ fill: props.fill || "transparent" }}
      viewBox={props.viewBox || "0 0 58 58"}
      width="58"
      height="58"
    >
      <rect width="58" height="58" rx="29" fill="white" />
      <path
        d="M23.7266 21.7102V36.2914C23.7266 37.4032 24.9523 38.0788 25.8962 37.4736L37.3643 30.183C38.2378 29.6341 38.2378 28.3674 37.3643 27.8044L25.8962 20.5279C24.9523 19.9227 23.7266 20.5983 23.7266 21.7102Z"
        fill="#0B0B0B"
      />
    </SvgIcon>
  );
};
